
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign-intelligence/charts",
      function () {
        return require("private-next-pages/campaign-intelligence/charts.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign-intelligence/charts"])
      });
    }
  